import { format, parseISO } from 'date-fns';

import { RosterRequestQuery } from 'generated/graphql';
import buildUserDisplayName from 'utilities/buildUserDisplayName';

import { useAppSelector } from '../../../store/store';
import { getControlFieldLabelForPod } from '../../../utilities/podBasedFiltering';

type HeaderProps = {
  request: RosterRequestQuery['rosterRequest'];
};

const Header = ({ request }: HeaderProps) => {
  const { pod: clientPod } = useAppSelector((state) => state.clientConfig);

  return (
    <>
      <span className="mr-4">ID: {request.id}</span>
      <span className="mr-4">
        {getControlFieldLabelForPod(clientPod)}: {request.controlNumber ?? '-'}
      </span>
      <span className="mr-4">
        Date Added: {format(parseISO(request.createdAt), 'M/d/yyyy')}
      </span>
      <span className="mr-4">
        Requested By: {buildUserDisplayName(request.requestedBy)}
      </span>
      {/* @todo confirm if this information should be present
      <span className="mr-4">
        Group:{' '}
        {request.assignedGroup
          ? getEnumLabel(rosterRequestGroups, request.assignedGroup)
          : '-'}
      </span> */}
    </>
  );
};

export default Header;
